import { CreateNewPostContent } from '@hhgtech/hhg-components'
import styled from 'styled-components'

export const StyledWrapper = styled.div`
  height: 100%;
  .ql-snow.ql-toolbar button {
    background: none;
    border: none;
    cursor: pointer;
    display: inline-block;
    float: left;
    height: 24px;
    padding: 3px 5px;
    width: 28px;
  }
  .ql-snow.ql-toolbar button svg {
    float: left;
    height: 100%;
  }
  .ql-snow .ql-stroke {
    fill: none;
    stroke: #444;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 2;
  }

  .ql-snow .ql-stroke.ql-thin,
  .ql-snow .ql-thin {
    stroke-width: 1;
  }

  .ql-toolbar.ql-snow {
    top: 0px;
    width: 100%;
    z-index: 3;
    border-top: none;
    border-right: none;
    border-left: none;
    border-image: initial;
    border-bottom: 1px solid rgb(204, 204, 204);
    background: white;
    padding: 8px;
  }

  .ql-snow .ql-hidden {
    display: none;
  }

  .ql-clipboard {
    left: -100000px;
    height: 1px;
    overflow-y: hidden;
    position: absolute;
    top: 50%;
  }

  .ql-editor {
    box-sizing: border-box;
    line-height: 1.42;
    height: 100%;
    outline: none;
    overflow-y: auto;
    padding: 12px 15px;
    -o-tab-size: 4;
    tab-size: 4;
    -moz-tab-size: 4;
    text-align: left;
    white-space: pre-wrap;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }

  .quill .ql-container {
    display: inline-block;
    width: 100%;
    min-height: 100%;
    height: 100%;
    border: none;
    border-radius: 6px;
    color: rgb(38, 38, 38);
    font-size: 1rem;
    line-height: 1.5;
    resize: none;
    white-space: break-spaces;
  }

  .quill {
    flex: 1 1 0%;
    overflow-y: hidden;
  }
`
export const StyledCreateNewPostContent = styled(CreateNewPostContent)`
  padding: 0;
`
